export default __webpack_public_path__ + "static/media/image-app-bar.a6af0323.png";